import { createFileRoute, redirect } from '@tanstack/react-router'

import { mayReadConfigurator } from '@brickup/shared/utils'
import { customerProjectQuery } from '@/api/configurator'
import { validateConfiguratorSearch } from '@/components/Customer/Configurator/configurator-search'
import { ConfiguratorPage } from '@/components/Customer/Configurator/ConfiguratorPage'
import { projectRoute } from '@/constants/routes'
import { asRoute } from '@/utils/runtime-route'

export const Route = createFileRoute('/customer/project/$projectId/configure')({
  // Full-height, and the customer's own surface: no shell around it.
  staticData: { chrome: 'bare' },
  validateSearch: validateConfiguratorSearch,
  // INTERNAL keeps the configurator invisible for the customer. OPEN and
  // LOCKED both open it — the page shows a locked banner in LOCKED.
  beforeLoad: async ({ context, params }) => {
    const projectId = Number(params.projectId)
    const project = await context.queryClient.ensureQueryData(
      customerProjectQuery({ projectId }),
    )
    // The same rule the server refuses the read by, and the project page
    // shows the link by. The customer's own route never sees an internal one.
    if (!project || !mayReadConfigurator(project, { seesInternal: false })) {
      throw redirect({ to: asRoute(projectRoute(projectId)) })
    }
  },
  component: ConfiguratorPage,
})
